export default __webpack_public_path__ + "static/media/Talons of the Unholy Communion.62bfa82e.jpg";